import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Text } from '@chakra-ui/react';
import { useMapContext } from '../../contexts/MapContext';
import { downloadMapImage, handleDownloadResponse } from '../../utilities/downloadMapImage';

export default function CreatorMapExportButton({ enableWatermark, background, exportQuality }) {
    const { data, isLoading } = useSelector((state) => state.media);
    const { user } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const { map } = useMapContext();

    const downloadProperties = {
        enableWatermark: enableWatermark,
        background: background,
        exportQuality: exportQuality,
    };

    useEffect(() => {
        handleDownloadResponse(data);
    }, [data]);

    return (
        <Box>
            <Button
                onClick={() => downloadMapImage(map, user, dispatch, downloadProperties)}
                isLoading={isLoading}
            >
                Export map image
            </Button>
            {
                isLoading && (
                    <Text fontSize='xs' style={{ marginTop: '5px' }}>
                        Generating screenshot (this may take up to 10 seconds)
                    </Text>
                )
            }
        </Box>
    );
}
